<template>
  <div class="special-option-button">
    <SmartLink
      class="special-option-button__link"
      :url="url"
      :route="route"
      :target="target"
      :method="method"
      :event="event"
    >
      <slot />
    </SmartLink>
  </div>
</template>

<script>
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    url: {
      type: String,
      default: null,
    },
    route: {
      type: [Object, String],
      default: null,
    },
    target: {
      type: String,
      default: '_blank',
      validator(value) { return ['_blank', '_self', '_parent', '_top'].includes(value); },
    },
    method: {
      type: Function,
      default: null,
    },
    event: {
      type: String,
      default: null,
    },
  },
  components: { SmartLink },
};
</script>

<style lang="scss" scoped>
.special-option-button {
  &__link {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #F6F6F9;
    border-radius: 8px;
    font-family: inherit;
    font-size: 20px;
    font-weight: 600;
    color: #020617;
    text-align: center;
    padding: 24px;
  }
}
</style>
